<template>
    <v-card
        tile
        class="d-inline-block item-card"
        :style="[PRODUCT.stock !== '' && PRODUCT.stock == 0 && {opacity: '.4'}, disabled != null && {pointerEvents: 'none', userSelect: 'none'}]"
        :disabled="!PRODUCT._id && disabled == null"
        :to="{name: `${PRODUCT.type || 'animals'}ProductView`, params: { id: (PRODUCT._id || 'id'), cacheData: PRODUCT }}"
        :ripple="false"
    >
        <v-img
            class="align-end grey lighten-2"
            :aspect-ratio="1.2"
            :src="src"
        >
        </v-img>

        <!-- <pre>{{PRODUCT}}</pre> -->
        <div class="px-2 py-1" style="min-height: 52px;">
            <v-row no-gutters class="flex-nowrap">
                <div class="text-truncate" style="letter-spacing: -0.03em;">
                    {{PRODUCT.title}}
                </div>
                <v-spacer></v-spacer>
                <template v-if="PRODUCT.type == 'animals' && PRODUCT.detail">
                    <v-icon small :class="sex.color[PRODUCT.detail.sex]">{{ sex.icon[PRODUCT.detail.sex] }}</v-icon>
                    <span v-if="birthYear">'{{birthYear}}</span>
                </template>
            </v-row>
            
            <!-- storeName SeperateRow (show only small screen) -->
            <div class="caption text-truncate hidden-sm-and-up" no-gutters>{{PRODUCT.store.storeName}}</div>
            
            <v-row no-gutters align="baseline" class="flex-nowrap caption" style="white-space: nowrap;">
                <!-- storeName - SignleRow (show only bigger screen) -->
                <div class="text-truncate hidden-xs-only" no-gutters>{{PRODUCT.store.storeName}}</div>
                <v-spacer></v-spacer>
                <span v-if="PRODUCT.price" :class="{'grey--text text--lighten-1 text-decoration-line-through': PRODUCT.discountPrice}">{{parseInt(PRODUCT.price).toLocaleString()}} ฿</span>
                <span v-if="PRODUCT.discountPrice" class="ml-1">{{parseInt(PRODUCT.discountPrice).toLocaleString()}} ฿</span>
            </v-row>
        </div>
    </v-card>
</template>

<script>
import { productThumbnailUrl } from "../../services/constants"
export default {
    props: ["product", "type", "disabled"], // product: {title, storeName, price, discountedPrice}
    data() {
        return {
            tPRODUCT: {
                title: ' ',
                price: '',
                discountPrice: 0,
                detail: {
                    sex: '',
                    age: '',
                },
                store: {
                    storeName: ' '
                },
            },
            PRODUCT: {},
            src: '', // 'https://picsum.photos/id/11/500/300',
            sex: {
                icon: {
                    m: 'mdi-gender-male',
                    w: 'mdi-gender-female',
                    o: ''
                },
                color: {
                    m: 'blue--text',
                    w: 'pink--text',
                }
            }
        }
    },
    created() {
        // console.log('M ', this.product);
        this.parseProduct();
    },
    watch: {
        product() {
            // console.log('U ', this.product);
            this.parseProduct();
        }
    },
    methods: {
        parseProduct() {
            // There still have some link in the deeper-level of object
            this.PRODUCT = { ...this.tPRODUCT ,...this.product };
            if (this.product && this.product.images && this.product.images[0])
                if (this.product.images[0].indexOf("http") == -1)
                    this.src = productThumbnailUrl(this.product.images[0]);
                else this.src = this.product.images[0];
            // this.PRODUCT.discountPrice = 1;
        }
    },
    computed: {
        birthYear() {
            if (!(this.PRODUCT.detail && this.PRODUCT.detail.birth)) return null;
            return new Date(this.PRODUCT.detail.birth).getFullYear().toString().slice(2);
        }
    }
};
</script>